import React, { useState, useRef } from 'react';
import ReactMapGL, {
  Marker,
  Popup,
  FlyToInterpolator,
  NavigationControl,
} from "react-map-gl";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import mapDine from "./map-items/map-dine.json";
import mapWork from "./map-items/map-work.json";
import mapLive from "./map-items/map-live.json";
import mapShop from "./map-items/map-shop.json";
import {
  MapWrapper,
  MapItemsCategories,
  NavItemsList,
  MapNav,
  MapMarker,
  PopupMapItemName,
  PopupMapItemAddress,
  MapContainer,
} from "./index.styled";

// eslint-disable-next-line import/no-webpack-loader-syntax
import MapboxWorker from 'worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker';
mapboxgl.workerClass = MapboxWorker;

const navControlStyle = {
  right: 10,
  top: 10,
};

const Map = () => {
  const categoriesList = useRef(null);
  const [zoom] = useState(14.6);
  const [lat] = useState(34.0360);
  const [lng] = useState(-118.23715);

  const [settings] = useState({
    scrollZoom: false,
    keyboard: false,
    maxZoom: 17,
    minZoom: 12,
  });

  const [viewport, setViewport] = useState({
    latitude: lat,
    longitude: lng,
    zoom,
    width: "99%",
    height: "100%",
  });
  const [selectedMapItem, setSelectedMapItem] = useState(null);
  const [selectedMapCategory, setSelectedMapCategory] = useState(mapShop);


  const AlphabeticalSort = () => {
    selectedMapCategory.features.sort((a, b) => {
      let nameA = a.properties.NAME.toLowerCase();
      let nameB = b.properties.NAME.toLowerCase();
      if (nameA < nameB) //sort string ascending
        return -1;
      if (nameA > nameB)
        return 1;
      return 0; //default return value (no sorting)
    })
  }
  AlphabeticalSort()
  const setCategoryActive = (cat) => {
    setSelectedMapCategory(cat);
  };
  const goToMarker = (item) => {
    setViewport({
      latitude: item.geometry.coordinates[0],
      longitude: item.geometry.coordinates[1],
      width: "99",
      height: "100%",
      zoom: zoom,
    });
    setSelectedMapItem(item);
  };
  return (
    <MapWrapper>
      <MapNav>
        <MapItemsCategories>
          <ul ref={categoriesList}>
            <li>
              <span onClick={() => {
                setCategoryActive(mapShop);
                setSelectedMapItem(null);
              }}>Shop</span>
                {selectedMapCategory.name === "shop" &&
                  <NavItemsList className={selectedMapCategory.name}>
                    {selectedMapCategory.features.map( (item, i) => {
                      return (
                        <p data-id={i+1} onClick={() => goToMarker(item)} key={item.properties.ID}>
                          {item.properties.NAME}
                        </p>
                        );
                      })
                    }
                  </NavItemsList>
                }
            </li>


            <li>
              <span onClick={() => {
                    setCategoryActive(mapDine);
                    setSelectedMapItem(null);
                  }}>Dine</span>
              {selectedMapCategory.name === "dine" &&
                <NavItemsList className={selectedMapCategory.name}>
                  {selectedMapCategory.features.map( (item, i) => {
                    return (
                      <p data-id={i+1} onClick={() => goToMarker(item)} key={item.properties.ID}>
                        {item.properties.NAME}
                      </p>
                      );
                    })
                  }
                </NavItemsList>
              }
            </li>

            <li>
              <span onClick={() => {
                setCategoryActive(mapLive);
                setSelectedMapItem(null);
              }}>Live</span>
              {selectedMapCategory.name === "live" &&
                <NavItemsList className={selectedMapCategory.name}>
                  {selectedMapCategory.features.map((item, i) => {
                    return (
                      <p data-id={i+1} onClick={() => goToMarker(item)} key={item.properties.ID}>
                        {item.properties.NAME}
                      </p>
                    );
                  })}
                </NavItemsList>
              }
            </li>

            <li>
              <span onClick={() => {
                setCategoryActive(mapWork);
                setSelectedMapItem(null);
              }}>Work</span>
              {selectedMapCategory.name === "work" &&
                <NavItemsList className={selectedMapCategory.name}>
                  {selectedMapCategory.features.map((item, i) => {
                    return (
                      <p data-id={i+1} onClick={() => goToMarker(item)} key={item.properties.ID}>
                        {item.properties.NAME}
                      </p>
                    );
                  })}
                </NavItemsList>
              }
            </li>
          </ul>
        </MapItemsCategories>
      </MapNav>

      <MapContainer>
        <ReactMapGL
          {...viewport}
          {...settings}
          mapStyle={"mapbox://styles/dboxcartifact/ckv8llg967qxe15phabg0k8bt"}
          mapboxApiAccessToken={
            "pk.eyJ1IjoiZGJveGNhcnRpZmFjdCIsImEiOiJja28zamNyMzUwYW5vMm9xd2JtMWYxeWQzIn0.CCNGewPeaiydOFITf8Rvyg"
          }
          transitionInterpolator={new FlyToInterpolator()}
          transitionDuration={300}
          onViewportChange={(nextViewport) => {
            setViewport(nextViewport);
          }}
        >
          <NavigationControl style={navControlStyle} />

          {selectedMapCategory.features.map((item, i) => (
            <Marker
              key={item.properties.ID}
              longitude={item.geometry.coordinates[1]}
              latitude={item.geometry.coordinates[0]}
            >
              <MapMarker
                onClick={(e) => {
                  e.preventDefault();
                  setSelectedMapItem(item);
                  setViewport({
                    latitude: item.geometry.coordinates[0],
                    longitude: item.geometry.coordinates[1],
                    zoom: viewport.zoom,
                    width: "100%",
                    height: "100%",
                  });
                }}
              >
                <span className={selectedMapCategory.name}>{i+1}</span>
              </MapMarker>
            </Marker>
          ))}

          {selectedMapItem ? (
            <Popup
              className={"popup-content"}
              longitude={selectedMapItem?.geometry.coordinates[1]}
              latitude={selectedMapItem?.geometry.coordinates[0]}
              onClose={() => setSelectedMapItem(null)}
            >
              <PopupMapItemName>
                {selectedMapItem?.properties.NAME}
              </PopupMapItemName>
              <PopupMapItemAddress>
                {selectedMapItem?.properties.ADDRESSFORCALLOUT}
              </PopupMapItemAddress>
            </Popup>
          ) : null}
        </ReactMapGL>
      </MapContainer>
    </MapWrapper>
  );
};
export default Map;
